import { render, staticRenderFns } from "./DefaultLanguage.vue?vue&type=template&id=50cd451a"
import script from "./DefaultLanguage.vue?vue&type=script&lang=ts"
export * from "./DefaultLanguage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50cd451a')) {
      api.createRecord('50cd451a', component.options)
    } else {
      api.reload('50cd451a', component.options)
    }
    module.hot.accept("./DefaultLanguage.vue?vue&type=template&id=50cd451a", function () {
      api.rerender('50cd451a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout-editor/DefaultLanguage.vue"
export default component.exports